import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

export const selectLodeStarFeeTypesByFeeTypeId = memoizeOne(feeTypeId =>
  createSelector(getSystem, ({ lodeStarFeeTypes }) => lodeStarFeeTypes[feeTypeId]),
);
